module.exports = __webpack_public_path__ + "img/IMG_2358.4c14e1c0.jpg";